<template>
    <div
        class="sportsSwitch"
        v-bind:class="{
            _show: sportsListShow,
            _fromWeb: !isFromApp,
        }"

        v-bind:style="{
            'z-index': isInOtherProduct ? 100 : undefined,
        }"
    >
        <div id="sportsSwitchEl" class="sportsSwitch-function">
            <div
                class="sportsSwitch-toggle JARVIS_Header2_DropDown_FeatureSports"
                v-on:click="toggleSportsList"
            >
                <span>{{ sportsSwitchTitle }}</span>
                <SvgIcon iconName="systemIcon_arrowBottom" />
            </div>
            <div
                v-if="!isInOtherProduct"
                class="sportsMixParlay"
            >
                <MixParlayToggle v-on:switchMpMode="switchMpMode" />
            </div>
        </div>

        <SportsSwitchList
            v-if="sportsListShow"
            v-bind:sportsInfo="sportsInfo"
            v-bind:loading="loading"
            v-bind:isInOtherProduct="isInOtherProduct"
            v-bind:refetch="refetch"
            v-on:close="closeSportsList"
        />
    </div>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue';
    import MixParlayToggle from '@/components/MixParlayToggle.vue';
    import SportsSwitchList from '@/components/sportsSwitch/SportsSwitchList.vue';
    import { useApp } from '@/libraries/composables/useApp';
    import useScroll from '@/libraries/composables/useScroll';
    import { useSportsSwitch } from '@/libraries/composables/useSportsSwitch';
    import { useSportsInfoQuery } from '@/libraries/oddsApi/composables/useSportsInfoQuery';
    import SvgIcon from '@/svg/SvgIcon.vue';

    interface Props {
        isInOtherProduct?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        isInOtherProduct: false,
    });

    const sportsListShow = ref(false);
    const { sportsInfo, refetch, loading } = useSportsInfoQuery(sportsListShow);
    const { sportsSwitchTitle, switchMpMode } = useSportsSwitch(props.isInOtherProduct);
    const { isFromApp } = useApp();

    function toggleSportsList() {
        sportsListShow.value = !sportsListShow.value;
    }

    function closeSportsList() {
        sportsListShow.value = false;
    }

    onMounted(() => {
        const { initHeaderDisplayHeight } = useScroll();
        initHeaderDisplayHeight(() => document.getElementById('sportsSwitchEl'), 'sportSwitchHeight');
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/sportsSwitch";
</style>
